import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Trigger new deploy
const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate a small delay for better UX
    await new Promise(resolve => setTimeout(resolve, 500));

    if (password === 'Titosmells1') {
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/message');
    } else {
      setError('Incorrect password, please try again 💔');
      setTimeout(() => setError(''), 3000);
    }
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f172a] px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -inset-[10px] opacity-50">
          <div className="w-full h-full bg-gradient-to-br from-pink-500/30 via-purple-500/30 to-blue-500/30 blur-3xl transform rotate-12"></div>
        </div>
      </div>

      <div className="w-full max-w-md relative">
        <div className="relative bg-white/10 backdrop-blur-xl rounded-3xl shadow-2xl p-6 sm:p-8 transform transition-all duration-500 hover:scale-[1.02] border border-white/20">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-pink-500/20 to-purple-600/20 z-0"></div>

          <div className="relative z-10">
            <div className="flex flex-col items-center space-y-4 sm:space-y-2">
              <div className="animate-float w-32 h-32 sm:w-40 sm:h-40">
                <img
                  src="/corgibutt.png"
                  alt="Corgi"
                  className="w-full h-full object-contain filter drop-shadow-lg"
                  style={{ imageRendering: 'pixelated' }}
                />
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 text-center">
                Naomi Portal
              </h1>
            </div>

            <form onSubmit={handleSubmit} className="mt-6 sm:mt-8 space-y-4">
              <div className="space-y-2">
                <div className="relative group">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white 
                             focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all duration-200
                             placeholder-white/30 backdrop-blur-sm group-hover:bg-white/10
                             text-base sm:text-lg"
                    placeholder="hey naomi"
                    required
                    autoFocus
                  />
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-pink-500/20 to-purple-600/20 opacity-0 group-hover:opacity-100 transition-opacity blur-xl -z-10"></div>
                </div>
              </div>

              {error && (
                <div className="bg-red-500/10 backdrop-blur-sm text-red-300 rounded-xl p-3 text-sm sm:text-base text-center animate-shake border border-red-500/20">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="relative w-full py-3 sm:py-4 px-6 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-xl font-medium 
                         hover:from-pink-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2
                         transform transition-all duration-300 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed
                         shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50 group
                         focus:ring-offset-[#0f172a]
                         text-base sm:text-lg"
              >
                <span className="absolute inset-0 rounded-xl bg-gradient-to-r from-pink-500 to-purple-600 opacity-0 group-hover:opacity-50 blur-xl transition-opacity"></span>
                <span className="relative flex items-center justify-center">
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Unlocking...
                    </>
                  ) : (
                    'Enter Portal ✨'
                  )}
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
